import { render } from "./CardControls.vue?vue&type=template&id=451f5048"
import script from "./CardControls.vue?vue&type=script&lang=js"
export * from "./CardControls.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__